import React from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Switch, Popover } from 'hljd'

export default store => {
  const isCorpMultiple =
    store.$list[0] && store.$list[0].is_corp_multiple ? 1 : 0
  return [
    // {
    //   title: 'ID',
    //   dataIndex: 'id',
    //   key: 'id'
    // },
    {
      title: '名称',
      dataIndex: 'nick',
      key: 'nick',
      align: 'center',
      render: (text, record) => {
        // const { m_role_name } = record || {}
        return (
          <p>
            {text}
            {/* <br />
          {m_role_name && (
            <span
              style={{
                backgroundColor: '#eee',
                color: '#999',
                padding: '0 6px',
                fontSize: '12px'
              }}
            >
              {m_role_name}
            </span>
          )} */}
          </p>
        )
      }
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      key: 'phone',
      align: 'center'
    },
    {
      title: '权限组',
      dataIndex: 'm_role_name',
      key: 'm_role_name'
    },
    {
      title: '所属店铺',
      dataIndex: 'merchants',
      key: 'merchants',
      render: (merchants, { is_corp_multiple }) =>
        merchants.map(({ name, city }) => {
          return (
            <div>
              {name}
              {`${city ? ' | ' + city : ''}`}
            </div>
          )
        }),
      hidden: () => isCorpMultiple == 0
    },
    {
      title: (
        <span>
          接收私信<Popover content="在线的账号才能接收到私信分配，客服和管理员可同时控制该开关">
            <QuestionCircleOutlined
              style={{ marginLeft: 6, color: '#448afc' }}
            />
          </Popover>
        </span>
      ),
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (status, { id, roles }) => {
        return (
          <div>
            <Switch
              checkedChildren={'在线'}
              unCheckedChildren={'离线'}
              checked={+status === 1}
              onChange={store.changeStatus(id, status, roles)}
            />
          </div>
        )
      }
    }
    /*{
    title: '操作',
    dataIndex: '',
    key: 'edit',
    render: (record, { id, nick, is_admin }) => {
      return (
        <div>
          {+is_admin === 1 ? (
            <a href="javascript:;" onClick={store.goModify(id, nick)}>
              修改备注
            </a>
          ) : (
            <p>
              <a href="javascript:;" onClick={addStore.editModal(record)}>
                编辑
              </a>
              <a
                href="javascript:;"
                style={{ margin: '0 20px' }}
                onClick={pwdStore.changePwd(id)}
              >
                修改密码
              </a>
              <a href="javascript:;" onClick={store.confirmDelete(id, nick)}>
                删除
              </a>
            </p>
          )}
        </div>
      )
    }
  }*/
  ]
}
